import { ENavTransparency, INavigation, INavParams } from '@features/navigation/typescript';
import { TCategoriesTree, TServiceMap } from '@features/categories/typescript';
import NavigationMobile from '@features/navigation/components/NavigationMobile/NavigationMobile';
import NavigationDesktop from '@features/navigation/components/NavigationDesktop/NavigationDesktop';
import { useResponsive } from '@features/responsive';
type PropsType = {
  navElements: INavigation;
  serviceMap: TServiceMap;
  navParams: INavParams;
  categoriesTree: TCategoriesTree;
};
const NavigationClient = ({
  navElements,
  categoriesTree,
  serviceMap,
  navParams
}: PropsType) => {
  const {
    navTransparency,
    backgroundColor,
    fontColorVariant,
    withBorder
  } = navParams;
  const {
    isWiderThanDesktop
  } = useResponsive();
  const navTransparencyMobile = navTransparency === ENavTransparency.BOTH_TRANSPARENT || navTransparency === ENavTransparency.DESKTOP_NOT_TRANSPARENT_MOBILE_TRANSPARENT;
  const navTransparencyDesktop = navTransparency === ENavTransparency.BOTH_TRANSPARENT || navTransparency === ENavTransparency.DESKTOP_TRANSPARENT_MOBILE_NOT_TRANSPARENT;
  return !isWiderThanDesktop ? <NavigationMobile navElements={navElements} categoriesTree={categoriesTree} serviceMap={serviceMap} isTransparent={navTransparencyMobile} backgroundColor={backgroundColor} /> : <NavigationDesktop navElements={navElements} categoriesTree={categoriesTree} serviceMap={serviceMap} isTransparent={navTransparencyDesktop} backgroundColor={backgroundColor} fontColorVariant={fontColorVariant} withBorder={withBorder} />;
};
export default NavigationClient;